<template>
  <!--
    Menu Ações do Diário de Auxiliares para anos anteriores a 2026 (#7286).

    Este é o markup que vivia em Pages/GestaoDeAulasAuxiliares/index.vue, recortado sem
    alteração de conteúdo. O comportamento de 2025 e anos anteriores tem que continuar
    exatamente o que era: não acrescentar nem remover opção daqui.
  -->
  <v-menu :close-on-content-click="false" :nudge-width="100" offset-x>
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        x-small
        color="indigo"
        dark
        v-bind="attrs"
        v-on="on"
        :id="`btn-acoes-auxiliares-legado-${gestaoDeAulas.id}`"
      >
        AÇÕES
      </v-btn>
    </template>

    <v-card class="mx-auto" max-width="300">
      <v-list>
        <v-list-item>
          <v-list-item-avatar color="primary">
            <v-list-item-title style="color: #fff">{{
              gestaoDeAulas.disciplina
                ? gestaoDeAulas.disciplina.descricao.substring(0, 1).toUpperCase()
                : "- - -"
            }}</v-list-item-title>
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title>{{
              gestaoDeAulas.nomeProfessor ? gestaoDeAulas.nomeProfessor : "- - -"
            }}</v-list-item-title>
            <v-list-item-subtitle
              >{{ gestaoDeAulas.nomeTurma ? gestaoDeAulas.nomeTurma : "- - -" }} /
              {{ gestaoDeAulas.nomeDisciplina ? gestaoDeAulas.nomeDisciplina : "- - -" }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-divider></v-divider>
      <v-list dense>
        <!-- item -->
        <v-list-item-group color="primary">
          <v-list-item
            :id="`item-lancar-relatorio-${gestaoDeAulas.id}`"
            :to="{
              name: 'gestoesAuxiliaresRelatorio.newEdit',
              params: {
                gestaoId: gestaoDeAulas.id,
              },
            }"
          >
            <v-list-item-icon>
              <v-icon small>fa fa-book</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Lançar relatório</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item
            :id="`item-gerar-relatorio-${gestaoDeAulas.id}`"
            @click="$emit('gerar-relatorio', gestaoDeAulas)"
          >
            <v-list-item-icon>
              <v-icon small>fa fa-file-pdf</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Gerar relatório</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
        <!-- item -->
        <v-list-item-group
          color="primary"
          v-if="
            !gestaoDeAulas.estaDeletado && $can(['gestoesDeAulas.atualizar', 'gestoesDeAulas.*'])
          "
        >
          <v-list-item
            :id="`item-editar-gestao-${gestaoDeAulas.id}`"
            @click="$emit('editar', gestaoDeAulas)"
          >
            <v-list-item-icon>
              <v-icon small>fa fa-edit</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Editar gestão de aulas</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
        <!-- item -->
        <v-list-item-group
          color="primary"
          v-if="
            !gestaoDeAulas.estaDeletado && $can(['gestoesDeAulas.atualizar', 'gestoesDeAulas.*'])
          "
        >
          <v-list-item
            :id="`item-apagar-gestao-${gestaoDeAulas.id}`"
            @click="$emit('deletar', gestaoDeAulas)"
          >
            <v-list-item-icon>
              <v-icon small>fa fa-trash</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Apagar gestão de aulas </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-card>
  </v-menu>
</template>

<script>
export default {
  name: "EAcoesAuxiliaresLegado",
  props: {
    gestaoDeAulas: {
      type: Object,
      required: true,
    },
  },
};
</script>
